/**
 * Scrolls to the element specified by the supplied elementSelector.
 * 
 * @param {Element} elementSelector 
 * @param {number} offset 
 * @param {string} behavior 
 */
export const scrollToElem = (elementSelector: any, offset = 0, behavior: any = "smooth") => {
    
    let element = elementSelector;
    
    if (!(elementSelector instanceof Element)) {
        element = document.querySelector(elementSelector);
    }

    if (element) {

        const headerOffset = 110;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = window.pageYOffset + elementPosition - headerOffset - offset;

        window.scrollTo({
            top: offsetPosition,
            behavior: behavior
        });

    }

};


/*!
 * Check if an element is out of the viewport
 * (c) 2018 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param  {Node}  elem The element to check
 * @return {Object}     A set of booleans for each side of the element
 */
export const isOutOfViewport = (elem: Element) => {

	// Get element's bounding
	const bounding = elem.getBoundingClientRect();

	// Check if it's out of the viewport on each side
	const out: any = {};
	out.top = bounding.top < 0;
	out.left = bounding.left < 0;
	out.bottom = bounding.bottom > (window.innerHeight || document.documentElement.clientHeight);
	out.right = bounding.right > (window.innerWidth || document.documentElement.clientWidth);
	out.any = out.top || out.left || out.bottom || out.right;
	out.all = out.top && out.left && out.bottom && out.right;

	return out;

};

export const scrollToFirstError = (errors: any) => {
    const keys = Object.keys(errors);
    if (keys.length > 0) {
        const selector = `[name=${keys[0]}]`;
        const errorElement = document.querySelector(selector);
        if (errorElement) {
            const isOut = isOutOfViewport(errorElement);
            if (isOut.any) {
                scrollToElem(errorElement, 30);
            }
        }
    }
};